import { graphql } from "../gql";

const getHeadToHeadTeamStatsQuery = graphql(`
  query GetHeadToHeadTeamStatsTab($input: OddsMarketTypesInput!) {
    event(input: $input) {
      odds {
        homeTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
        }
        awayTeamTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
        }
        alternateTotalPoints {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
        }
        totalPointsOddOrEven {
          selectionId
          odds
          handicap
          formattedHandicap
          runnerName
          runnerStatus
          url
          sortPriority
        }
      }
      playerPropOdds {
        anyTimeTouchdownScorer {
          formattedHandicap
          handicap
          odds
          runnerName
          selectionId
          url
          sortPriority
          player {
            name
            numberfireId
            position
            imageUrl
            teamInfo {
              shortName
              logo {
                svg
              }
            }
          }
        }
        firstTouchdownScorer {
          formattedHandicap
          handicap
          odds
          runnerName
          selectionId
          url
          sortPriority
          player {
            name
            numberfireId
            position
            imageUrl
            teamInfo {
              shortName
              logo {
                svg
              }
            }
          }
        }
      }
      homeTeam {
        abbreviation
        shortName
        logoSVG
        teamStats {
          successStats {
            rankedStats {
              offense {
                rank
                value
              }
              passing {
                rank
                value
              }
              rushing {
                rank
                value
              }
              defense {
                rank
                value
              }
              passDefense {
                rank
                value
              }
              rushDefense {
                rank
                value
              }
            }
          }
          defensiveStats {
            rankedStats {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
            last5Games {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
            last3Games {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
          }
        }
        gameLog {
          homeTeam
          timestamp
          score
          week
          passingYards
          passingTDs
          opponentPassDefRank
          rushingYards
          rushingTDs
          opponentRushDefRank
          passYardsAllowed
          opponentPassingRank
          rushYardsAllowed
          opponentRushingRank
          opponentTeam {
            abbreviation
            logoSVG
          }
        }
      }
      awayTeam {
        abbreviation
        shortName
        logoSVG
        teamStats {
          successStats {
            rankedStats {
              offense {
                rank
                value
              }
              passing {
                rank
                value
              }
              rushing {
                rank
                value
              }
              defense {
                rank
                value
              }
              passDefense {
                rank
                value
              }
              rushDefense {
                rank
                value
              }
            }
          }
          defensiveStats {
            rankedStats {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
            last5Games {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
            last3Games {
              rankedSacks {
                rank
                value
              }
              rankedHomeSacks {
                rank
                value
              }
              rankedAwaySacks {
                rank
                value
              }
              rankedPDR {
                rank
                value
              }
              rankedHomePDR {
                rank
                value
              }
              rankedAwayPDR {
                rank
                value
              }
            }
          }
        }
        gameLog {
          homeTeam
          timestamp
          score
          week
          passingYards
          passingTDs
          opponentPassDefRank
          rushingYards
          rushingTDs
          opponentRushDefRank
          passYardsAllowed
          opponentPassingRank
          rushYardsAllowed
          opponentRushingRank
          opponentTeam {
            abbreviation
            logoSVG
          }
        }
      }
    }
  }
`);

export default getHeadToHeadTeamStatsQuery;
